import { Codebook } from '../Codebook'

export enum ISDOCVersionId {
  V5_3_1 = '5.3.1',
  V6_0_1 = '6.0.1',
  V6_0_2 = '6.0.2',
}

export class ISDOCVersion extends Codebook<ISDOCVersionId> {
  static readonly V5_3_1 = new ISDOCVersion(ISDOCVersionId.V5_3_1, '5.3.1')
  static readonly V6_0_1 = new ISDOCVersion(ISDOCVersionId.V6_0_1, '6.0.1')
  static readonly V6_0_2 = new ISDOCVersion(ISDOCVersionId.V6_0_2, '6.0.2')

  private constructor(
    public readonly id: ISDOCVersionId,
    public readonly name: string,
  ) {
    super(id)
  }
}
